import * as Yup from "yup";
import { useFormik } from "formik";
import { patch } from "../../../../../api/util";
import { getPatchOperations } from "../../../../../util/form";
import {
  ApolloQueryResult,
  OperationVariables,
} from "@apollo/client/core/types";
import { Fmulinje } from "../../../../../interfaces/schema";

export const useLinjeoplysninger = (
  initialValues: Fmulinje,
  setEditMode: (editMode: boolean) => void,
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      fmulinje: Fmulinje;
    }>
  >,
) =>
  useFormik({
    initialValues,
    validationSchema: Yup.object({
      navn: Yup.string().required("Navn krævet"),
    }),
    onSubmit: async (values) => {
      const body: Partial<Fmulinje> = {
        navn: values.navn,
        hotelId: values.hotelId,
      };
      await patch({
        query: `fmulinje/${values.id}`,
        body: JSON.stringify(getPatchOperations(body)),
      });
      setEditMode(false);
      refetch();
    },
    enableReinitialize: true,
  });
